/**
 * Utility functions for async operations
 */

import { logger } from '../logger';

/**
 * Execute a promise without awaiting it (fire-and-forget pattern).
 * Logs errors but doesn't throw, useful for non-critical background operations.
 *
 * @param promise - Promise to execute
 * @param onError - Optional error handler (defaults to debug logging)
 */
export function fireAndForget<T>(promise: Promise<T>, onError?: (error: Error) => void): void {
  promise.catch((error) => {
    const err = error instanceof Error ? error : new Error(String(error));
    if (onError) {
      onError(err);
    } else {
      logger.debug('Fire-and-forget operation failed', { error: err.message });
    }
  });
}
